import Store from "$common/utils/store";

export default {
  GET_STORE_lIST(state, params = []) {
    state.merchant = params.merchant.merchantName
    Store.saveObject('merchant', params.merchant.merchantName)
    state.storeList = params.store
    Store.saveObject('storeList', params.store)
    if (params.store?.length === 1) {
      const obj = params.store[0]
      state.storeNo = obj.storeNo
      Store.saveObject('prepareStatus', obj.status)
      Store.saveObject('storeNo', obj.storeNo)
      state.storeName = obj.storeName
      Store.saveObject('storeName', obj.storeName)
      state.businessStatus = obj.storeStatus
      Store.saveObject('businessStatus', obj.storeStatus)
    }
  },
  GET_STORE_lISTS(state, params = []) {
    state.merchant = params?.merchant?.merchantName ?? ''
    Store.saveObject('merchant', params.merchant.merchantName)
    state.storeList = params.store
    Store.saveObject('storeList', params.store)
    if (params.store.length === 1) {
      const obj = params.store[0]
      state.storeNo = obj.storeNo
      Store.saveObject('prepareStatus', obj.status)
      Store.saveObject('storeNo', obj.storeNo)
      state.storeName = obj.storeName
      Store.saveObject('storeName', obj.storeName)
      state.businessStatus = obj.storeStatus
      Store.saveObject('businessStatus', obj.storeStatus)
    }
    if (params.store.length > 1) {
      const res = params.store.find(i => i.storeNo == Store.loadObject('storeNo'))
      if (res) {
        state.businessStatus = res.storeStatus
      }
    }
  },
  GET_STORE_NO(state, params = '') {
    state.storeNo = params
  },
  SET_ACCESS_TOKEN(state, params = '') {
    state.accessToken = params
  },
  SET_OPERATOR_NO(state, params = '') {
    state.operatorNo = params
  },
  SET_LOGIN_NAME(state, params) {
    state.loginName = params
  },
  SET_BUSINESS_STATE(state, {status = '', storeStatus}) {
    if (status) {
      state.prepareStatus = status
    }
    state.businessStatus = storeStatus
  },
  SET_SIDER_BAR_COUNT(state, params) {
    state.sideCount = params
  },
  SET_AUTO_ORDER(state, params) {
    state.autoOrder = params
  }
}
